import Bugsnag from "@bugsnag/js";
import { QueryCache, QueryClient } from "@tanstack/svelte-query";
import { ApiError } from "../api/errors";
import { errorLog } from "../utils/logger";

declare module "@tanstack/svelte-query" {
  interface Register {
    queryMeta: {
      /** Also report failures to Bugsnag, not only to the console. */
      notify?: boolean;
    };
  }
}

/** Retry network failures and server errors a few times. Other answers (a 404, say) won't change. */
export function retryTransient(failureCount: number, error: unknown): boolean {
  return (
    failureCount < 3 &&
    error instanceof ApiError &&
    (error.status === undefined || error.status >= 500)
  );
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        errorLog(error, `Could not fetch ${JSON.stringify(query.queryKey)}`);
        if (query.meta?.notify) {
          Bugsnag.notify(error);
        }
      },
    }),
    defaultOptions: {
      // The React app made each call once and never refetched on focus; queries that should retry
      // or live longer say so (see `sessionData`).
      queries: { retry: false, refetchOnWindowFocus: false },
    },
  });
}

export const queryClient = createQueryClient();
